import restClient, { RestRequestOptions, RestResponse } from '.';
import {
  AttachmentAudio,
  AttachmentImage,
  AttachmentVideo,
  TtsLocale,
  Uuid,
} from '../../models/Base';
import {
  Audio,
  GetUrlToGetFileData,
  Icon,
  Image,
  ResourceImage,
  Stroke,
  TtsAudio,
  Video,
} from '../../models/FileStore/file';
import { Scope } from '../utils';

export const getUrlToGetAttachmentImage = (
  path: { contextType: string; contextId: string; key: string },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<AttachmentImage>>> => {
  return restClient.get(
    `/files/attachments/${path.contextType}/${path.contextId}/images/${path.key}`,
    params,
    options,
  );
};

export const getUrlToGetAttachmentAudio = (
  path: { contextType: string; contextId: string; key: string },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<AttachmentAudio>>> => {
  return restClient.get(
    `/files/attachments/${path.contextType}/${path.contextId}/audios/${path.key}`,
    params,
    options,
  );
};

export const getUrlToGetAttachmentVideo = (
  path: { contextType: string; contextId: string; key: string },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<AttachmentVideo>>> => {
  return restClient.get(
    `/files/attachments/${path.contextType}/${path.contextId}/videos/${path.key}`,
    params,
    options,
  );
};

export const getUrlToGetImage = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } & Scope = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<Image>>> => {
  return restClient.get(
    `/files/media-files/images/${path.fileId}`,
    params,
    options,
  );
};

export const getUrlToGetIcon = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } & Scope = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<Icon>>> => {
  return restClient.get(
    `/files/media-files/icons/${path.fileId}`,
    params,
    options,
  );
};

export const getUrlToGetAudio = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } & Scope = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<Audio>>> => {
  return restClient.get(
    `/files/media-files/audios/${path.fileId}`,
    params,
    options,
  );
};

export const getUrlToGetVideo = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } & Scope = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<Video>>> => {
  return restClient.get(
    `/files/media-files/videos/${path.fileId}`,
    params,
    options,
  );
};

export const getUrlToGetResourceImage = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<ResourceImage>>> => {
  return restClient.get(
    `/files/resources/resource-images/${path.fileId}`,
    params,
    options,
  );
};

export const getUrlToGetStroke = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<Stroke>>> => {
  return restClient.get(
    `/files/resources/strokes/${path.fileId}`,
    params,
    options,
  );
};

interface GetTtsAudiosResponse {
  ttsAudios: (TtsAudio | null)[];
}

export const getTtsAudios = <
  P extends {
    texts: string[];
    locale: TtsLocale;
    voice?: string;
    speed?: number;
    volume?: number;
    pitch?: number;
  },
>(
  params: P = {} as P,
  options?: RestRequestOptions,
): Promise<RestResponse<GetTtsAudiosResponse>> => {
  return restClient.get(`/files/resources/tts-audios`, params, options);
};

export const getUrlToGetTtsAudio = (
  path: { fileId: Uuid },
  params: { version?: string; hash?: string } = {},
  // TODO: hash in 'if-none-match' header
  options?: RestRequestOptions,
): Promise<RestResponse<GetUrlToGetFileData<TtsAudio>>> => {
  return restClient.get(
    `/files/resources/tts-audios/${path.fileId}`,
    params,
    options,
  );
};
